.all-products {
  background-color: #f7f7f7;
}

@media screen and (max-width: 979px) {
  .all-products {
    display: flex;
    flex-direction: column-reverse;
  }
}

.all-products__main-content {
  position: relative;
}

@media screen and (min-width: 980px) {
  .all-products__main-content {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
    padding-bottom: 30px;
  }

  .all-products__main-content--menu-opened::after {
    content: "";
    position: absolute;
    left: 0;
    right: 0;
    top: 58px;
    bottom: 0;
    background: #666666;
    opacity: 0.7;
    z-index: 1;
  }
}

@media screen and (max-width: 979px) {
  .all-products__header {
    margin: 0;
    color: #333333;
    text-align: center;
    padding: 24px 0 16px;
    font-size: 24px;
    line-height: 36px;
    font-weight: 700;
    width: 100%;
  }
}

@media screen and (min-width: 980px) {
  .all-products__header {
    display: none;
  }
}

@media screen and (min-width: 980px) {
  .all-products__section {
    display: flex;
    flex-wrap: wrap;
    width: 1200px;
    max-width: 1200px;
    padding: 0;
    box-sizing: border-box;
  }

  .all-products__section *,
.all-products__section *::before,
.all-products__section *::after {
    box-sizing: inherit;
  }
}

.all-products__section--inactive {
  display: none;
}

.all-products__section-title-wrapper {
  display: none;
}

@media screen and (min-width: 980px) {
  .all-products__section-title-wrapper {
    display: flex;
    flex-basis: 100%;
    height: 52px;
  }
}

.all-products__section-title {
  display: inline-flex;
  align-items: center;
  padding: 0 10px;
  font-size: 22px;
  line-height: 30px;
  font-weight: 700;
  color: #333333;
  text-decoration: none;
}

.all-products__section-title-icon {
  position: relative;
  top: 2px;
}

:host(:not([dir="rtl"])) .all-products__section-title-icon {
  left: 8px;
}

:host([dir="rtl"]) .all-products__section-title-icon {
  right: 8px;
  transform: scaleX(-1);
}

@media screen and (min-width: 980px) {
  .all-products__top-categories {
    display: block;
    width: 100%;
  }
}

.all-products__menu-category {
  display: none;
}

@media screen and (min-width: 980px) {
  .all-products__menu-category {
    position: relative;
    display: block;
    width: 25%;
    padding: 6px 10px 0;
  }
}

@media screen and (min-width: 980px) {
  .all-products__top-runners {
    display: flex;
    flex-flow: wrap;
    align-content: flex-start;
    width: 75%;
  }
}